var u = Object.defineProperty;
var i = (e, t, r) => t in e ? u(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var s = (e, t, r) => i(e, typeof t != "symbol" ? t + "" : t, r);
import { defineComponent as m, resolveComponent as c, createBlock as f, openBlock as l, createSlots as d, renderList as h, withCtx as _, renderSlot as $, normalizeProps as g, guardReactiveProps as I } from "vue";
import b from "./InputNumber-CJ1ZLzd0.js";
import { _ as S } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const N = m({
  components: { TInputNumber: b },
  setup: () => ({ formatter: new C() })
});
class C {
  constructor() {
    s(this, "validators", [
      (t) => !t || /^[0-9]*[h:]{0,1}[0-9]{0,2}$/.test(t.replace(/ /g, ""))
    ]);
  }
  /** import('@/plugins/i18n').Formatte.duration */
  stringify(t) {
    if (!t) return "";
    const r = t % 60;
    return `${(t - r) / 60} h ` + r.toFixed(0).padStart(2, "0");
  }
  parse(t) {
    let r = 0;
    const n = (t || "").toString().replace(/ /g, "").split(/h|:/);
    return n.length > 0 && (r += (parseInt(n[0]) || 0) * 60), n.length > 1 && (r += parseInt(n[1]) || 0), r;
  }
}
function T(e, t, r, n, k, w) {
  const p = c("TInputNumber");
  return l(), f(p, {
    formatter: e.formatter,
    step: 60,
    min: 0,
    default: "1h10 / 1:10 / 1"
  }, d({ _: 2 }, [
    h(e.$slots, (x, o) => ({
      name: o,
      fn: _((a) => [
        $(e.$slots, o, g(I(a ?? {})))
      ])
    }))
  ]), 1032, ["formatter"]);
}
const v = /* @__PURE__ */ S(N, [["render", T]]);
export {
  v as default
};
//# sourceMappingURL=InputNumberDuration-CGgyR8Yg.js.map
